module.exports = __webpack_public_path__ + "img/FMS-Truck.79c7ed37.png";